import "./about.css";

const VALUES = [
  {
    icon: "fa-shield-halved",
    title: "Trust & Transparency",
    text: "We put honesty and clarity at the core of everything we do.",
  },
  {
    icon: "fa-user-gear",
    title: "Customer First",
    text: "Your goals drive our solutions and every recommendation.",
  },
  {
    icon: "fa-award",
    title: "Expertise You Can Rely On",
    text: "Backed by experienced professionals and industry knowledge.",
  },
];

// const STATS = [
//   { icon: "fa-clock", value: "10+", label: "Years of Experience" },
//   { icon: "fa-face-smile", value: "50K+", label: "Happy Customers" },
//   { icon: "fa-chart-column", value: "INR 5,000 Cr+", label: "Assets Served" },
//   { icon: "fa-handshake", value: "25+", label: "Partner Institutions" },
// ];

export default function AboutHero() {
  return (
    <section className="about-hero-new">
      <div className="about-hero-wave about-hero-wave--bl" aria-hidden="true" />
      <div className="about-hero-wave about-hero-wave--br" aria-hidden="true" />

      <div className="about-hero-inner">
        <div className="about-hero-copy">
          <p className="about-eyebrow">ABOUT GPS FINVEST</p>
          <h1 className="about-hero-title">
            Empowering Financial Journeys. Building{" "}
            <span>Stronger Futures.</span>
          </h1>
          <p className="about-hero-lead">
            At GPS Finvest, we believe that every financial decision today
            creates a better tomorrow. We are committed to simplifying
            investments, loans, and wealth management with trust, transparency
            and technology.
          </p>

          <div className="about-values">
            {VALUES.map((item) => (
              <div key={item.title} className="about-value">
                <span className="about-value-icon" aria-hidden="true">
                  <i className={`fa-solid ${item.icon}`} />
                </span>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="about-hero-visual">
          <div className="about-hero-media">
            <img
              src="/images/about-team-office.png"
              alt="GPS Finvest team collaborating in the office"
            />
          </div>
          {/* <div className="about-stats">
            {STATS.map((stat) => (
              <div key={stat.label} className="about-stat">
                <span className="about-stat-icon" aria-hidden="true">
                  <i className={`fa-solid ${stat.icon}`} />
                </span>
                <strong>{stat.value}</strong>
                <span>{stat.label}</span>
              </div>
            ))}
          </div> */}
        </div>
      </div>
    </section>
  );
}
